export default {
    complete: 'Completo',
};
